import React from "react";
import { Link } from "react-router-dom";
import { XCircle, RefreshCw, Mail } from "lucide-react";
import { Button } from "../../components/ui/button";

const Failure = () => {
    return (
        <div className="min-h-screen bg-[#070710] flex items-center justify-center p-4">
            <div className="max-w-md w-full text-center space-y-8 animate-in fade-in zoom-in duration-500">
                <div className="relative group">
                    <div className="absolute -inset-1 bg-gradient-to-r from-red-500 to-orange-600 rounded-full blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200"></div>
                    <div className="relative bg-[#070710] rounded-full p-4 inline-block">
                        <XCircle className="w-20 h-20 text-red-500" />
                    </div>
                </div>

                <div className="space-y-4">
                    <h1 className="text-4xl font-bold text-white tracking-tight">
                        Payment Failed
                    </h1>
                    <p className="text-gray-400 text-lg">
                        We couldn't process your payment. Please check your card details or try a different payment method.
                    </p>
                </div>

                <div className="grid grid-cols-1 gap-4 pt-8">
                    <Link to="/user">
                        <Button className="w-full bg-white/10 hover:bg-white/20 text-white py-6 text-lg border border-white/10 group">
                            <RefreshCw className="mr-2 w-5 h-5 group-hover:rotate-180 transition-transform duration-500" />
                            Try Again
                        </Button>
                    </Link>

                    {/* <a href="mailto:support@guideproai.com">
                        <Button variant="ghost" className="w-full text-gray-400 hover:text-white hover:bg-transparent py-4 group">
                            <Mail className="mr-2 w-4 h-4" />
                            Contact Support
                        </Button>
                    </a> */}
                </div>

                <div className="text-xs text-gray-600">
                    Transaction declined by your bank or payment provider.
                </div>
            </div>
        </div>
    );
};

export default Failure;
